import React, { useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";


const ArchiveYearSelector = ({ onYearChange }) => {
  const currentYear = new Date().getFullYear();
  const earliestYear = 2013;
  const league_test = true;
  const [startYear, setStartYear] = useState(league_test ? currentYear : currentYear - 1);
  const [selectedYear, setSelectedYear] = useState(league_test ? currentYear : currentYear - 1 );

  // Generate 6 years starting from startYear
  const generateYearRange = () => {
    return Array.from({ length: 6 }, (_, i) => startYear - i).filter(
      (year) => year >= earliestYear
    );
  };

  const handleLeftArrowClick = () => {
    // Slide left: bring in a higher year (if not already at currentYear)
    if (startYear < currentYear) {
      setStartYear((prev) => prev + 1);
    }
  };

  const handleRightArrowClick = () => {
    // Slide right: bring in a lower year (if not already at earliestYear)
    if (startYear - 5 > earliestYear) {
      setStartYear((prev) => prev - 1);
    }
  };

  const handleYearSelect = (year) => {
    setSelectedYear(year);
    onYearChange(year, "cy");
  };

  const yearRange = generateYearRange();

  return (
    <div className="flex items-center justify-center space-x-4">
      <button
        onClick={handleLeftArrowClick}
        disabled={startYear >= currentYear}
        className={`
          p-2 rounded-full 
          ${startYear >= currentYear ? "text-gray-300 cursor-not-allowed" : "text-black hover:bg-gray-100"}
        `}
      >
        <LeftOutlined />
      </button>

      <div className="flex space-x-2">
        {yearRange.map((year) => (
          <div
            key={year}
            onClick={() => handleYearSelect(year)}
            className={`
              px-3 py-1 rounded-md cursor-pointer
              ${selectedYear === year 
                ? "bg-[#A26F35] text-white" 
                : "bg-white border border-[#A26F35] text-[#A26F35] hover:bg-gray-50"}
            `}
          >
            {year}
          </div>
        ))}
      </div>

      <button
        onClick={handleRightArrowClick}
        disabled={yearRange[yearRange.length - 1] <= earliestYear}
        className={`
          p-2 rounded-full 
          ${yearRange[yearRange.length - 1] <= earliestYear ? "text-gray-300 cursor-not-allowed" : "text-black hover:bg-gray-100"}
        `}
      >
        <RightOutlined />
      </button>
    </div>
  );
};

export default ArchiveYearSelector;
